import $http from '../http/index'
import { DataDictionary } from '../Entity/DataDictionary'
import { BaseUser } from '../Entity/BaseUser'
import { HandleResult, ExcelHandleException } from '../Entity/DataImport'
import { ElMessage } from 'element-plus';


interface LanguageInfo {
    CN: string,
    EN: string
}

const allLanguages: Array<LanguageInfo> = [];

/**
 * 文件下载
 * @param url 
 */
const fileDownload = (url: string) => {
    const link = document.createElement("a");
    link.style.display = "none";
    link.href = `${process.env.VUE_APP_BASE_API}${url}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

class Helper {
    getAlphabet(){
        const baseChars:Array<string> = [
            'A','B','C','D','E',
            'F','G','H','I','J',
            'K','L','M','N','O',
            'P','Q','R','S','T',
            'U','V','W','X','Y',
            'Z'];
        const result:Array<string> = JSON.parse(JSON.stringify(baseChars));
        return result;
    }

    /**
     * 生成唯一键
     */
    createID() {
        const baseChars:Array<string> = ['A','B','C','D','E','F','G','H','I','J','K'];
        let str ='';
        for(let i=0;i<7;i++){
            const randomNum = Math.floor(Math.random() * 11);
            str = str + baseChars[randomNum]
        }
        return 'AU'+Date.now()+str;
    }

    /**
     * 
     * @param obj 获取对象字段名
     */
    getObjectFieldNames<T extends object>(obj: T): Array<keyof T> {
        return Object.keys(obj) as Array<keyof T>;
    }

    /**
     * 获取数据字典
     * @param classifyCode 
     */
    getDataDictionary(classifyCode: string) {
        const cacheData = window.localStorage.getItem("DataDictionary");
        const resultData: Array<DataDictionary> = [];
        if (cacheData) {
            const datas: Array<DataDictionary> = JSON.parse(cacheData);
            for (let i = 0; i < datas.length; i++) {
                if (datas[i].ClassifyCode == classifyCode) resultData.push(datas[i]);
            }
            return resultData
        }
        return []
    }

    /**
     * 获取字典的显示文本
     * @param classifyCode 
     * @param dictionaryCode 
     * @returns 
     */
    getDataDictionaryShowText(classifyCode: string, dictionaryCode: string) {
        const cacheData = window.localStorage.getItem("DataDictionary");
        let dictionaryValue = '';
        if (cacheData) {
            const datas: Array<DataDictionary> = JSON.parse(cacheData);
            for (let i = 0; i < datas.length; i++) {
                if (datas[i].ClassifyCode == classifyCode && datas[i].DictionaryCode == dictionaryCode) {
                    dictionaryValue = datas[i].DictionaryValue
                    break;
                }
            }
        }
        return dictionaryValue
    }

    /**
     * 文件数据导入（excel）
     * @param file 上传的文件
     * @param handleType 上传文件的处理类型（C#类名）
     * @param handleParam 处理参数（不需要携带处理参数时可以传入{}即可）
     * @param finishedCallBack 文件上传完成时的回调函数
     * @returns 无
     */
    fileDataImport(file: File, handleType: string, handleParam: object, finishedCallBack: (result: HandleResult) => void) {
        if (!file) return;
        const reader = new FileReader();
        reader.readAsDataURL(file);////将文件读取为 DataURL,也就是base64编码
        reader.onload = function () { //文件读取成功完成时触发
            const fileContent = reader.result; //获得文件读取成功后的DataURL,也就是base64编码
            if (fileContent == null) return;
            const fileContentStr = fileContent.toString()
            // 每个文件切片大小定为256K .
            const bytesPerPiece = 1024 * 256;
            //计算文件切片总数
            const totalPieces = Math.ceil(fileContentStr.length / bytesPerPiece);
            if (totalPieces == 0) { //空文件
                return;
            }
            const fileContents: Array<string> = []
            for (let currentPiece = 1; currentPiece <= totalPieces; currentPiece++) {
                const startIndex = (currentPiece - 1) * bytesPerPiece;
                const getLength = currentPiece * bytesPerPiece > fileContentStr.length ? fileContentStr.length - startIndex : bytesPerPiece;
                fileContents.push(fileContentStr.slice(startIndex, startIndex + getLength));
            }
            const fileContentKeys: Array<string> = []
            const fileID = $helper.createID();
            for (let index = 0; index < fileContents.length; index++) {
                const dto = {
                    FileID: fileID,
                    CurrentPiece: index,
                    FileContent: fileContents[index]
                }
                $http({
                    url: "/DataImport/FileContentUpload",
                    method: "POST",
                    data: JSON.stringify(dto),
                }).then(res => {
                    fileContentKeys.push(res.data);
                    // 文件分片已经全部上传完成，即将处理文件
                    if (fileContentKeys.length == fileContents.length) {
                        const handleDto = {
                            Keys: fileContentKeys,
                            HandleType: handleType,
                            HandleParam: handleParam,
                            FileName: file.name
                        }
                        $http({
                            url: "/DataImport/HandleFilePieceUpload",
                            method: "POST",
                            data: JSON.stringify(handleDto),
                        }).then(res => {
                            const result: HandleResult = res.data;
                            if (result.Code == 1) {
                                ElMessage.info(result.Message);
                            }
                            else if (result.Code == 0) {
                                ElMessage.error(result.Message);
                                //下载错误文件
                                const handleInfo: ExcelHandleException = JSON.parse(result.Data)
                                fileDownload(`/DataImport/ErrorFileDownload?cacheKey=${handleInfo.HandleData}`);
                            }
                            finishedCallBack(result);
                        })
                        // const reinitData:HandleResult={
                        //     Code:100,
                        //     Message:'',
                        //     Data:''
                        // }
                        // finishedCallBack(reinitData);
                    }
                })
            }
        }
    }

    /**
     * 文件上传
     * @param file 
     * @param handleParam 
     * @param finishedCallBack 
     * @returns 
     */
    fileUpload(file: File, handleParam: object, finishedCallBack: (result: string) => void) {
        if (!file) return;
        const reader = new FileReader();
        reader.readAsDataURL(file);////将文件读取为 DataURL,也就是base64编码
        reader.onload = function () { //文件读取成功完成时触发
            const fileContent = reader.result; //获得文件读取成功后的DataURL,也就是base64编码
            if (fileContent == null) return;
            const fileContentStr = fileContent.toString()
            // 每个文件切片大小定为256K .
            const bytesPerPiece = 1024 * 256;
            //计算文件切片总数
            const totalPieces = Math.ceil(fileContentStr.length / bytesPerPiece);
            if (totalPieces == 0) { //空文件
                return;
            }
            const fileContents: Array<string> = []
            for (let currentPiece = 1; currentPiece <= totalPieces; currentPiece++) {
                const startIndex = (currentPiece - 1) * bytesPerPiece;
                const getLength = currentPiece * bytesPerPiece > fileContentStr.length ? fileContentStr.length - startIndex : bytesPerPiece;
                fileContents.push(fileContentStr.slice(startIndex, startIndex + getLength));
            }
            const fileContentKeys: Array<string> = []
            const fileID = $helper.createID();
            for (let index = 0; index < fileContents.length; index++) {
                const dto = {
                    FileID: fileID,
                    CurrentPiece: index,
                    FileContent: fileContents[index]
                }
                $http({
                    url: "/DataImport/FileContentUpload",
                    method: "POST",
                    data: JSON.stringify(dto),
                }).then(res => {
                    fileContentKeys.push(res.data);
                    // 文件分片已经全部上传完成，即将处理文件
                    if (fileContentKeys.length == fileContents.length) {
                        const handleDto = {
                            Keys: fileContentKeys,
                            HandleParam: handleParam,
                            FileName: file.name
                        }
                        $http({
                            url: "/BaseAttachFile/HandleFilePieceUpload",
                            method: "POST",
                            data: JSON.stringify(handleDto),
                        }).then(res => {
                            finishedCallBack(res.data);

                            // const result:HandleResult = res.data;
                            // // if(result.Code==1){
                            // //     ElMessage.info(result.Message);
                            // // }
                            // // else if(result.Code==0){
                            // //     ElMessage.error(result.Message);
                            // //     //下载错误文件
                            // //     const handleInfo:ExcelHandleException = JSON.parse(result.Data)
                            // //     fileDownload(`/DataImport/ErrorFileDownload?cacheKey=${handleInfo.HandleData}`);
                            // // }
                            // debugger
                            // if(result.Code==1){

                            // }
                            // else{
                            //     finishedCallBack('');
                            // }
                        })
                    }
                })
            }
        }
    }

    /**
     * 数字格式转换成千分位
     * @param num 
     * @returns 
     */
    commafy(num: any) {
        const defaultValue = "0";
        if (num == null || isNaN(num)) {
            return defaultValue;
        }
        let inputValue = `${num}`;
        if (/^.*\..*$/.test(inputValue)) {
            const pointIndex = inputValue.lastIndexOf(".");
            let intPart = inputValue.substring(0, pointIndex);
            const pointPart = inputValue.substring(pointIndex + 1, inputValue.length);
            intPart = intPart + "";
            const re = /(-?\d+)(\d{3})/
            while (re.test(intPart)) {
                intPart = intPart.replace(re, "$1,$2")
            }
            inputValue = intPart + "." + pointPart;
        } else {
            inputValue = inputValue + "";
            const re = /(-?\d+)(\d{3})/
            while (re.test(inputValue)) {
                inputValue = inputValue.replace(re, "$1,$2")
            }
        }
        return inputValue;
    }

    /**
     * 是否有权限
     * @param code 权限编码
     * @returns 结果。true:有权限 false：无权限
     */
    hasPermission(code: string) {
        const permissionCodesStr = window.localStorage.getItem("PermissionCodes");
        if (permissionCodesStr) {
            const codes: Array<string> = JSON.parse(permissionCodesStr);
            if (codes.indexOf(code) > -1)
                return true;
        }
        return false;
    }

    /**
     * 获取权限编码
     * @param callBack 
     */
    getPermissionCodes(): Array<string> {
        const permissionCodesStr = window.localStorage.getItem("PermissionCodes");
        if (permissionCodesStr) {
            const codes: Array<string> = JSON.parse(permissionCodesStr);
            return codes;
        }
        return [];
    }

    /**
     * 获取用户的品牌信息
     * @returns 品牌数组
     */
    getUserBrands() {
        const userInfoJson = window.localStorage.getItem("userInfo");
        let brands: Array<string> = [];
        if (!userInfoJson) {
            return brands;
        }
        else {
            brands = JSON.parse(userInfoJson).Brand.split(',');
        }
        return brands;
    }

    // 多语言转换
    lan(cnContent: string | null | undefined) {
        if (!cnContent) {
            return '';
        }
        const lanType = window.localStorage.getItem('lanType');
        if (!lanType || lanType == 'CN') {
            return cnContent;
        }
        if (allLanguages.length < 1) {
            const lanJson = window.localStorage.getItem("lan");
            if (lanJson) {
                const lans = JSON.parse(lanJson);
                for (let i = 0; i < lans.length; i++) {
                    allLanguages.push(lans[i])
                }
            }
        }
        for (let i = 0; i < allLanguages.length; i++) {
            const lan = allLanguages[i];
            if (lan.CN == cnContent) {
                return lan.EN;
            }
        }
        return cnContent;
    }

    /**
     * 将2014年1月 转成 01/2024
     * @param inputDate 
     * @returns 
     */
    convertDate(inputDate: string) {
        if (!inputDate) {
            return '';
        }
        let inputStr = inputDate.replace('年', '-');
        inputStr = inputStr.replace('月', '');
        const yearMonth = inputStr.split('-');
        if (yearMonth.length != 2) {
            return '';
        }
        if (yearMonth[1].length < 2) {
            return `0${yearMonth[1]}/${yearMonth[0]}`;
        }
        return `${yearMonth[1]}/${yearMonth[0]}`;
    }

    /**
     * 日期格式化 yyyy-MM-dd
     * @param d 
     */
    dateFormat(d: Date | string | null | undefined) {
        if (!d) return '';
        const date: Date = new Date(d)
        const year = date.getFullYear();
        const month = `0${date.getMonth() + 1}`.slice(-2);
        const day = `0${date.getDate()}`.slice(-2);
        return `${year}-${month}-${day}`;
    }

        /**
     * 日期格式化 yyyy-MM-dd HH:mm
     * @param d 
     */
    dateTimeFormat(d: Date | string | null | undefined) {
        if (!d) return '';
        const date: Date = new Date(d)
        const year = date.getFullYear();
        const month = `0${date.getMonth() + 1}`.slice(-2);
        const day = `0${date.getDate()}`.slice(-2);
        const hour = `0${date.getHours()}`.slice(-2);
        const minute = `0${date.getMinutes()}`.slice(-2);
        return `${year}-${month}-${day} ${hour}:${minute}`;
    }

    /**
     * 获取当前时间的字符串
     * @returns 
     */
    getDateTimeString() {
        const date: Date = new Date()
        const year = date.getFullYear();
        const month = `0${date.getMonth() + 1}`.slice(-2);
        const day = `0${date.getDate()}`.slice(-2);
        const h = `0${date.getHours()}`.slice(-2);
        const m = `0${date.getMinutes()}`.slice(-2);
        const s = `0${date.getSeconds()}`.slice(-2);
        return `${year}${month}${day}${h}${m}${s}`;
    }

    /**
     * 文件下载
     * @param url 下载地址
     */
    fileDownload(url: string) {
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = `${process.env.VUE_APP_BASE_API}${url}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    /**
     * 当前用户
     */
    currentUser() {
        const jsonStr = window.localStorage.getItem("CurrentUser");
        if (jsonStr) {
            const baseUser: BaseUser = JSON.parse(jsonStr);
            return baseUser;
        }
    }

    /**
     * 获取当前用户的数据分类权限
     * @returns 
     */
    getCurrentDataClassifyPermission() {
        const permissions: Array<string> = [];
        const jsonStr = window.localStorage.getItem("CurrentUser");
        if (!jsonStr) {
            return permissions;
        }
        const baseUser: BaseUser = JSON.parse(jsonStr);
        if (!baseUser.DataClassifyPermission) {
            return permissions;
        }
        const dataClassifies: Array<string> = JSON.parse(baseUser.DataClassifyPermission);
        for (let i = 0; i < dataClassifies.length; i++) {
            permissions.push(dataClassifies[i]);
        }
        return permissions;
    }

    /**
     * 判定能否转成数值
     * @param str 
     * @returns 
     */
    isNumericString(str: string): boolean {
        const num = parseFloat(str);
        return !isNaN(num) && isFinite(num);
    }

    /**
     * 导出
     * @param url 导出的URL
     * @param queryParam 查询数据参数
     */
    Export(url:string,queryParam:object){
        $http({
            url: url,
            method: "POST",
            data: JSON.stringify(queryParam)
        }).then(res => {
            $helper.fileDownload(`/${url}FileDownload?cacheKey=${res.data}`)
        });
    }
}


const $helper = new Helper()

export default $helper